
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/tarabily",
      function () {
        return require("private-next-pages/case-study/tarabily.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/tarabily"])
      });
    }
  